import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import {
  TextInput,
  PasswordTextInput,
  FormInputError,
} from "@toddle-edu/ds-web";
import classes from "./InputTextField.scss";
import classNames from "classnames";
import { inputHTMLAttributes } from "Constants";
class FormTextInput extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.errorId = _.uniqueId("form-error-");
  }
  handleKeyPress = e => {
    const { handleKeyPress } = this.props;
    if (e.key === "Enter") {
      const param = {};
      param[e.target.name] = e.target.value;
      if (this.props.onEnter) {
        this.props.onEnter(param);
      }
    }
    if (handleKeyPress) {
      handleKeyPress(e);
    }
  };

  renderEdit = () => {
    const {
      size,
      disabled,
      type,
      value,
      textInputLabel,
      inputContainerClass,
      testId,
      style,
      customErrorClass,
      labelSuffix,
      titleSuffix,
      dsVersion = "1.0",
      helperText,
      autoFocus,
      "aria-describedby": ariaDescribedBy,
      ...rest
    } = this.props;

    const errorMessage = this.state.error ? this.state.error : "";

    const InputComponent = type === "password" ? PasswordTextInput : TextInput;

    const containerClass = classNames(
      "w-full",
      classes.containerClass,
      inputContainerClass
    );

    const errorClass = classNames(classes.errorClass, customErrorClass);

    const isValidHelperElement = !!helperText;

    return (
      <div className={containerClass}>
        <InputComponent
          {..._.pick(rest, inputHTMLAttributes)}
          size={size}
          onChange={e => this.updateValue(e.target.value)}
          ref={this.updateInputRef}
          error={errorMessage}
          label={textInputLabel}
          disabled={disabled}
          onKeyPress={this.handleKeyPress}
          onBlur={e => this.onBlur({ value: e.target.value })}
          onFocus={e => this.onFocus({ value: e.target.value })}
          value={value ? value : ""}
          testId={testId}
          style={style}
          type={type}
          labelSuffix={labelSuffix}
          titleSuffix={titleSuffix}
          dsVersion={dsVersion}
          autoFocus={autoFocus}
          aria-describedby={ariaDescribedBy ?? this.errorId}
        />
        <FormInputError
          id={this.errorId}
          dsVersion={dsVersion}
          testId={testId}
          {...(!_.isEmpty(errorMessage) && {
            className: errorClass,
            error: errorMessage,
          })}
        />
        {isValidHelperElement && !errorMessage ? helperText : null}
      </div>
    );
  };
}

FormTextInput.defaultProps = {
  ...UIBaseComponent.defaultProps,
  inputStyle: {},
  type: "text",
  size: "medium",
  autoFocus: false,
  showErrorText: false,
  ["data-test-id"]: "input-form-text",
  customErrorClass: {},
  dsVersion: "1.0",
  helperText: "",
};

FormTextInput.propTypes = {
  ...UIBaseComponent.propTypes,
  onBlur: PropTypes.func,
  inputStyle: PropTypes.object,
  onEnter: PropTypes.func,
  updateInputRef: PropTypes.func,
  showErrorText: PropTypes.bool,
  leadingIcon: PropTypes.element,
  trailingIcon: PropTypes.element,
  customErrorClass: PropTypes.object,
  labelSuffix: PropTypes.element,
  titleSuffix: PropTypes.element,
  dsVersion: PropTypes.string,
  helperText: PropTypes.any,
  autoFocus: PropTypes.bool,
};

export default FormTextInput;
